if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.submitButton = this.querySelector('[type="submit"]');
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.removeErrorMessage();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
        }
      }

      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll('input[type="radio"]:checked'),
          (radio) => radio.value
        );
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const swiper = document.querySelector(".swiper-product");
        if (swiper && swiper.swiper) {
          const slides = swiper.querySelectorAll(".swiper-slide");
          const slideIndex = Array.from(slides).findIndex((slide) => {
            const img = slide.querySelector("img");
            if (!img) return false;
            const mediaId = img.getAttribute("data-media-id");
            return (
              mediaId &&
              mediaId === this.currentVariant.featured_media.id.toString()
            );
          });

          if (slideIndex >= 0) {
            swiper.swiper.slideTo(slideIndex);
          }
        }
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      updateVariantInput() {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;

        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
      }

      renderProductInfo() {
        const variantData = this.getVariantData();
        const isFirstVariant =
          variantData[0] && this.currentVariant.id === variantData[0].id;

        const priceElement = document.querySelector("[data-price]");
        if (priceElement && this.currentVariant.price) {
          const formattedPrice = (this.currentVariant.price / 100)
            .toFixed(2)
            .replace(".", ",");
          priceElement.textContent = formattedPrice + " €";
        }

        const compareAtPriceElement = document.querySelector(
          "[data-compare-at-price]"
        );
        if (compareAtPriceElement) {
          if (
            this.currentVariant.compare_at_price &&
            this.currentVariant.compare_at_price > this.currentVariant.price
          ) {
            const formattedComparePrice = (
              this.currentVariant.compare_at_price / 100
            )
              .toFixed(2)
              .replace(".", ",");
            compareAtPriceElement.textContent = formattedComparePrice + " €";
            compareAtPriceElement.style.display = "";
          } else {
            compareAtPriceElement.style.display = "none";
          }
        }

        const priceContainer = document.querySelector("[data-price-container]");
        const unitPriceContainer = document.querySelector(
          ".product-price-unit"
        );

        if (priceContainer && unitPriceContainer) {
          if (isFirstVariant) {
            priceContainer.classList.add("d-none");
            unitPriceContainer.classList.remove("d-none");
          } else {
            priceContainer.classList.remove("d-none");
            unitPriceContainer.classList.add("d-none");
          }
        }

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        const quantityInput = document.querySelector("input[data-quantity]");
        if (quantityInput && this.currentVariant) {
          const productWrapper = document.querySelector("product-wrapper");
          const isPreorder =
            productWrapper && productWrapper.dataset.preorder === "true";
          const maxQuantity =
            isPreorder && this.currentVariant.inventory_quantity <= 0
              ? 100
              : this.currentVariant.inventory_quantity;
          quantityInput.setAttribute("max", maxQuantity);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }
    }
  );
}
